'use client'

import React from 'react'
import Image from 'next/image'
import { useLanguage } from '@/app/(frontend)/providers/LanguageProvider'
import { motion } from 'framer-motion'
import { easeOut } from 'framer-motion'

const containerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: easeOut,
    },
  },
}

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      delay: 0.4 + i * 0.3,
    },
  }),
}

const ConnectWithUs = () => {
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  const contacts = [
    {
      href: 'https://www.linkedin.com/company/container-city-qatar/',
      icon: '/icons/linkedin.svg',
      title: isArabic ? 'لينكدإن' : 'Linkedin',
      description: isArabic
        ? 'تابع Container City®'
        : 'Follow Container City® Qatar',
    },
    {
      href: 'https://wa.me/97455618135',
      icon: '/icons/whatsapp.svg',
      title: isArabic ? 'واتساب' : 'WhatsApp',
      description: <span dir="ltr">+974 5561 8135</span>,
    },
  ]

  return (
    <section className="w-full bg-white flex justify-center items-start py-40 md:py-52 xl:pt-52 xl:pb-48 lg:items-center h-auto">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
        className="section-container mx-auto h-auto xl:h-[147px] flex flex-col items-center justify-center gap-6 sm:gap-8 md:gap-10"
      >
        <h2
          className={`text-[#414141] text-[24px] md:text-[24px] lg:text-[28px] xl:text-[38px] font-[500] ${
            isArabic ? 'text-right md:text-center' : 'text-left md:text-center'
          } w-full`}
        >
          {isArabic ? 'تواصل معنا' : 'Connect With Us'}
        </h2>

        <div className="flex flex-col sm:flex-row items-start justify-center sm:items-center gap-6 sm:gap-6 lg:gap-16  sm:px-[10px] xl:px-[90px] xl:gap-20 2xl:gap-48 xl:mt-[25px] w-full">
          {contacts.map((item, index) => (
            <motion.a
              key={index}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
              className="flex w-full sm:w-auto items-start sm:items-center gap-4 xl:gap-[16px]"
            >
              <Image   
                src={item.icon}
                alt={item.title}
                width={24}
                height={24}
                className="xl:size-[40px]"
              />
              <div className="flex flex-col text-left text-[#414141] gap-[2px]">
                <span className="text-sm sm:text-[14px] md:text-[15px] font-[600] xl:text-[16px]">
                  {item.title}
                </span>
                <span className="text-xs sm:text-[12px] md:text-[13px] text-[#404040] xl:text-[15px]">
                  {item.description}
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </motion.div>
    </section>
  )
}

export default ConnectWithUs
